// src/IT/pages/ITNewRequest.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createITRequest } from "../../api/ITapi";
import RequestTypeFields from "../components/RequestTypeFields";
//import "../IT/it.css";
export default function ITNewRequest() {
  const nav = useNavigate();

  const [request_type, setType] = useState("License");
  const [title, setTitle] = useState("");
  const [description, setDesc] = useState("");
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!title.trim() || !description.trim()) {
      alert("Title and Description are required.");
      return;
    }
    setLoading(true);
    try {
      const req = await createITRequest({
        request_type,
        title: title.trim(),
        description: description.trim(),
        details,
      });
      nav(`/it/req/${req.id}`);
    } catch (e) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="it-page">
      <div className="it-card">
        <div className="it-card-title">Create IT Request</div>

        <div className="it-grid2">
          <label className="it-field">
            <div className="it-label">Request Type</div>
            <select value={request_type} onChange={(e) => setType(e.target.value)}>
              {["License", "Software", "VM", "Hardware", "Laptop", "Research", "Other"].map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </label>

          <label className="it-field">
            <div className="it-label">Title</div>
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Short title..." />
          </label>

          <label className="it-field" style={{ gridColumn: "1 / -1" }}>
            <div className="it-label">Description</div>
            <textarea
              value={description}
              onChange={(e) => setDesc(e.target.value)}
              placeholder="Describe the request clearly..."
            />
          </label>
        </div>

        <div style={{ marginTop: 10 }}>
          <div className="it-label">Type-specific details</div>
          <RequestTypeFields requestType={request_type} details={details} setDetails={setDetails} />
        </div>

        <div className="it-actions">
          <button className="it-btn" onClick={submit} disabled={loading}>
            {loading ? "Submitting..." : "Submit for Manager Approval"}
          </button>
        </div>

        <div style={{ marginTop: 12 }}>
          <div className="it-muted">Details JSON preview</div>
          <pre className="it-pre">{JSON.stringify(details || {}, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
